import { Checkbox, HStack, Table, Text } from '@chakra-ui/react'
import type { InterestedSib } from '../types'

interface InterestedSibsTableProps {
  sibs: InterestedSib[]
  selectedSibIds: string[]
  onSelectionChange: (sibIds: string[]) => void
}

export function InterestedSibsTable({
  sibs,
  selectedSibIds,
  onSelectionChange,
}: InterestedSibsTableProps) {
  function toggleSib(sibId: string) {
    if (selectedSibIds.includes(sibId)) {
      onSelectionChange(selectedSibIds.filter(id => id !== sibId))
      return
    }

    onSelectionChange([...selectedSibIds, sibId])
  }

  return (
    <Table.Root>
      <Table.Header>
        <Table.Row>
          <Table.ColumnHeader width="60px" />
          <Table.ColumnHeader>SIB</Table.ColumnHeader>
          <Table.ColumnHeader>Location</Table.ColumnHeader>
          <Table.ColumnHeader>Status</Table.ColumnHeader>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {sibs.map(sib => (
          <Table.Row key={sib.id}>
            <Table.Cell>
              <Checkbox.Root
                checked={selectedSibIds.includes(sib.id)}
                onCheckedChange={() => toggleSib(sib.id)}
              >
                <Checkbox.HiddenInput />
                <Checkbox.Control />
              </Checkbox.Root>
            </Table.Cell>

            <Table.Cell>
              <Text fontWeight="medium">{sib.name}</Text>
            </Table.Cell>

            <Table.Cell>
              <HStack gap={1}>
                {sib.postalCode && <Text>{sib.postalCode}</Text>}
                {sib.city && <Text>{sib.city}</Text>}
              </HStack>
            </Table.Cell>

            <Table.Cell>{sib.confirmed ? 'Confirmed' : sib.interestStatus}</Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table.Root>
  )
}
